/**
 * Created by Victor Rojo on 20/9/17.
 */
import { Component, OnInit }        from '@angular/core';
import { FormGroup, FormControl,
         FormBuilder, Validators }  from '@angular/forms';
import { NotificationsService }     from 'angular2-notifications';

import { CloudUserService }         from "./cloudUser.service";
import { AuthService }              from "../shared/auth/auth.service";
import { CloudUser }                from "../model/cloudUser";
import { CloudAccount }             from "../model/cloudAccount";
import { CloudAccountService }      from "./cloudAccount.service";
import { I18NService }              from "../shared/i18n/i18n.service";

@Component({
  templateUrl: './profile.component.html',
  styleUrls: [ './profile.component.css'],
})
export class ProfileComponent implements OnInit{

  profileForm: FormGroup;
  securityForm: FormGroup;
  accountForm: FormGroup;
  isProfileBusy = false;
  isSecurityBusy = false;
  isAccountBusy = false;
  cloudUser: CloudUser;
  cloudAccount: CloudAccount;
  isAdmin = false;
  public toastOptions = {
    position: ["top", "right"],
    timeOut: 3000,
    theClass: "bg-teal",
    lastOnBottom: true,
    showProgressBar: true,
    pauseOnHover: false,
  };

  constructor(private fb: FormBuilder,
              private authService: AuthService,
              private cloudUserService: CloudUserService,
              private cloudAccountService: CloudAccountService,
              private i18nService: I18NService,
              private notificationService: NotificationsService) {
    let pattern = /^[A-Za-z0-9\S\*]*$/;
    this.profileForm = fb.group({
      'userName' : [null, Validators.required],
      'login' : [null, Validators.compose([Validators.required, Validators.pattern(pattern)])],
      'emailAddress' : [null, Validators.compose([Validators.required, Validators.email])],
    });

    this.securityForm = fb.group({
      'oldPassword' : [null, Validators.required],
      'newPassword' : [null, Validators.compose([Validators.required, Validators.minLength(6), Validators.pattern(pattern)])],
      'confirmPassword' : [null, Validators.compose([Validators.required, Validators.minLength(6), Validators.pattern(pattern)])],
    }, {
      validator: this.matchPassword
    });

    this.accountForm = fb.group({
      'accountName' : [null, Validators.compose([Validators.required, Validators.pattern(pattern)])],
      'company' : [null],
      'address' : [null],
      'emailAddress' : [null, Validators.compose([Validators.required, Validators.email])],
    });
    let roles = this.authService.getUserRoles();
    this.isAdmin = roles.reduce( (carry, value) => carry || value == "ROLE_END_USER_ADMIN", false);
  }

  ngOnInit():void {
    this.cloudUserService
      .get(this.authService.getUserID())
      .then( response => {
        this.cloudUser = response;
        this.cloudAccount = response.cloudAccount;
        this.profileForm.controls['userName'].setValue(this.cloudUser.userName);
        this.profileForm.controls['login'].setValue(this.cloudUser.login);
        this.profileForm.controls['emailAddress'].setValue(this.cloudUser.emailAddress);
        this.accountForm.controls['accountName'].setValue(this.cloudAccount.accountName);
        this.accountForm.controls['company'].setValue(this.cloudAccount.company);
        this.accountForm.controls['address'].setValue(this.cloudAccount.address);
        this.accountForm.controls['emailAddress'].setValue(this.cloudAccount.emailAddress);

      })
      .catch(error => {
        console.log(error)
      });
  }

  matchPassword(group: FormGroup):any {
    let password = group.get('newPassword').value;
    let confirmPassword = group.get('confirmPassword').value;
    if(password != confirmPassword) {
      group.get('confirmPassword').setErrors( { matchPassword: true } );
    }
  }

  onBlurChecker(fieldName: string):void{
    let filter = fieldName + ":" + this.profileForm.controls[fieldName].value;
    if ( this.profileForm.controls[fieldName].value != this.cloudUser[fieldName]) {
      this.cloudUserService.check(filter)
        .then( res => {
          if ( res ) {
            this.profileForm.controls[fieldName].setErrors( { used: true})
          }
        })
    }
  }

  onBlurAccountChecker(fieldName: string):void{
    let filter = fieldName + ":" + this.accountForm.controls[fieldName].value;
    if ( this.accountForm.controls[fieldName].value != this.cloudAccount[fieldName]) {
      this.cloudAccountService.check(filter)
        .then( res => {
          if ( res ) {
            this.accountForm.controls[fieldName].setErrors( { used: true})
          }
        })
    }
  }

  saveProfile():void {
    let changes = {};
    let changed = false;

    let fields = ['userName','login','emailAddress'];
    fields.forEach( field => {
      if ( this.profileForm.controls[field].dirty ){
        changes[field] = this.profileForm.controls[field].value;
        changed = true;
      }
    });
    if ( changed && this.profileForm.valid ) {
      this.isProfileBusy = true;
      this.cloudUserService.patch(this.cloudUser.idCloudUser, changes)
        .then( res => {
          this.isProfileBusy = false;
          fields.forEach(field => {
            this.cloudUser[field] = changes[field];
            if (this.profileForm.controls[field].value == changes[field]) {
              this.profileForm.controls[field].markAsPristine();
            }
          });
          this.notificationService.success(
            this.i18nService.get("success"),
            this.i18nService.get("dataSaved")
          );
        })
        .catch( error => {
          this.isProfileBusy = false;
          this.notificationService.error(
            this.i18nService.get("error") ,
            this.i18nService.get("cantSaveData")
          );
        })
    }
  }
  changePassword():void{
    if ( this.securityForm.valid ) {
      this.isSecurityBusy = false;
      let data = {
        oldPassword: this.securityForm.controls['oldPassword'].value,
        newPassword: this.securityForm.controls['newPassword'].value
      };
      this.cloudUserService.changePassword(this.cloudUser.idCloudUser, data)
        .then( res => {
          this.isSecurityBusy = false;
          this.securityForm.reset();
          this.notificationService.success(
            this.i18nService.get("success"),
            this.i18nService.get("dataSaved")
          );
        })
        .catch( error => {
          this.isSecurityBusy = false;
          this.notificationService.error(
            this.i18nService.get("error") ,
            this.i18nService.get("cantSaveData")
          );
        })
    }
  }

  saveAccount():void {
    let changes = {};
    let changed = false;

    let fields = ['accountName','company','address','emailAddress'];
    fields.forEach( field => {
      if ( this.accountForm.controls[field].dirty ){
        changes[field] = this.accountForm.controls[field].value;
        changed = true;
      }
    });
    if ( changed && this.accountForm.valid ) {
      this.isAccountBusy = true;
      this.cloudAccountService.patch(this.cloudAccount.idCloudAccount, changes)
        .then( res => {
          this.isAccountBusy = false;
          fields.forEach(field => {
            this.cloudAccount[field] = changes[field];
            if (this.accountForm.controls[field].value == changes[field]) {
              this.accountForm.controls[field].markAsPristine();
            }
          });
          this.notificationService.success(
            this.i18nService.get("success"),
            this.i18nService.get("dataSaved")
          );
        })
        .catch( error => {
          this.isAccountBusy = false;
          this.notificationService.error(
            this.i18nService.get("error") ,
            this.i18nService.get("cantSaveData")
          );
        })
    }
  }
}
